// Onboarding option catalogs — shared by widget + full page surfaces.
export const ROLE_OPTIONS = [
  { value: "student", label: "Student" },
  { value: "parent", label: "Parent" },
  { value: "working_professional", label: "Working Pro" },
];

// Expanded grade/level list so AskPurple knows the exact class.
export const LEVEL_OPTIONS = [
  { value: "class_8", label: "Class 8" },
  { value: "class_9", label: "Class 9" },
  { value: "class_10", label: "Class 10" },
  { value: "class_11", label: "Class 11" },
  { value: "class_12", label: "Class 12" },
  { value: "undergrad", label: "Undergrad" },
  { value: "postgrad", label: "Postgrad" },
  { value: "working", label: "Working" },
  { value: "other", label: "Other" },
];

// Curriculum boards recognised across India + intl schools.
export const CURRICULUM_OPTIONS = [
  { value: "cbse", label: "CBSE" },
  { value: "icse", label: "ICSE" },
  { value: "ib", label: "IB" },
  { value: "igcse", label: "IGCSE / Cambridge" },
  { value: "state_board", label: "State Board" },
  { value: "university", label: "University" },
  { value: "other", label: "Other" },
];

export const NEED_OPTIONS = [
  { value: "counselling", label: "Career Counselling" },
  { value: "admissions", label: "Admissions" },
  { value: "tutoring", label: "Tutoring" },
  { value: "exploring", label: "Just Exploring" },
];

// Textbook / exam-prep prompt is only useful when the person is a student or
// parent and still in school/college. Working professionals can skip it.
export function shouldAskCurriculum(role) {
  return role === "student" || role === "parent";
}

export function shouldAskTextbookPrefs(role, level) {
  if (!shouldAskCurriculum(role)) return false;
  // Working / other levels don't need textbook prefs
  return level !== "working" && level !== "other";
}
